import React from 'react'
import { Col, Nav, Row, Tab } from 'react-bootstrap'
import {
  LocationTab,
  ProviderTab,
  ProviderTypeTab,
  PenaltyTab,
  CDTCodeTab,
  CDTCategoryTab,
  ServiceTypeTab,
} from '@components/pages/Dashboard/ScorecardsPage'

function Scorecards(): React.ReactElement {
  return (
    <Row className="mt-2 mb-2 chart-tab morning-huddle">
      <Col md={12}>
        <Tab.Container defaultActiveKey={'location'}>
          <Col md={12} className="p-0">
            <Nav variant="pills" className="chart-tab">
              <Nav.Item key={`0`} className="">
                <Nav.Link eventKey={'location'}>{'Location'}</Nav.Link>
              </Nav.Item>
              <Nav.Item key={`1`} className="">
                <Nav.Link eventKey={'provider'}>{'Provider'}</Nav.Link>
              </Nav.Item>
              <Nav.Item key={`2`} className="">
                <Nav.Link eventKey={'provider-type'}>
                  {'Provider Type'}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item key={`3`} className="">
                <Nav.Link eventKey={'penalty'}>{'Penalty'}</Nav.Link>
              </Nav.Item>
              <Nav.Item key={`4`} className="">
                <Nav.Link eventKey={'cdt-code'}>{'CDT Code'}</Nav.Link>
              </Nav.Item>
              <Nav.Item key={`5`} className="">
                <Nav.Link eventKey={'cdt-category'}>{'CDT Category'}</Nav.Link>
              </Nav.Item>
              <Nav.Item key={`6`} className="">
                <Nav.Link eventKey={'service-type'}>{'Service Type'}</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col md={12} className="p-0">
            <Tab.Content className="">
              <Tab.Pane eventKey={'location'}>
                <LocationTab />
              </Tab.Pane>
              <Tab.Pane eventKey={'provider'}>
                <ProviderTab />
              </Tab.Pane>
              <Tab.Pane eventKey={'provider-type'}>
                <ProviderTypeTab />
              </Tab.Pane>
              <Tab.Pane eventKey={'penalty'}>
                <PenaltyTab />
              </Tab.Pane>
              <Tab.Pane eventKey={'cdt-code'}>
                <CDTCodeTab />
              </Tab.Pane>
              <Tab.Pane eventKey={'cdt-category'}>
                <CDTCategoryTab />
              </Tab.Pane>
              <Tab.Pane eventKey={'service-type'}>
                <ServiceTypeTab />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Tab.Container>
      </Col>
    </Row>
  )
}

export default Scorecards
